import { Box } from '@betterment/style-closet-react';

const VR = ({ ...boxProps }) => {
  return <Box borderLeft="1px solid" borderColor="bmtGrey20" {...boxProps} />;
};

export default VR;
